// extracted by mini-css-extract-plugin
export default {"tupacGrid":"vr-z","tupacHeader":"wr-z","tupacHeader2":"xr-z","tupacMenu":"yr-z","tupacMenu2":"zr-z","tupacMain":"Ar-z","tupacMain2":"Br-z"};